import { AnrokAuthConnectRequestSchema } from '@vy/api-definition';
import type { oz } from '@vy/utils';
import type { Control } from 'react-hook-form';

export const AnrokRegisterFormSchema = AnrokAuthConnectRequestSchema;

export type AnrokRegisterFormValues = oz.infer<typeof AnrokRegisterFormSchema>;
export type AnrokRegisterFormControl = Control<AnrokRegisterFormValues>;
